import { heroStats, heroTicker } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20editorial%20background%20with%20deep%20charcoal%20and%20warm%20vermilion%20red%20light%20streaks%2C%20subtle%20film%20grain%20texture%2C%20dramatic%20spotlight%20from%20top%20center%2C%20minimalist%20cinematic%20lighting%2C%20plenty%20of%20dark%20negative%20space%2C%20high%20contrast%2C%20clean%20modern%20art%20direction&width=1600&height=900&seq=hl-hero-main-01&orientation=landscape"
          alt="黑料平台官网首屏视觉背景图"
          title="黑料平台 - 功能 内容 板块 服务 玩法 特色"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80" />
        <div className="hero-noise absolute inset-0 opacity-40" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-shell px-4 pb-14 pt-32 md:px-6 md:pb-20 md:pt-44">
        <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.24em] text-accent-400">
          <span className="h-px w-8 bg-accent-400" />
          爆料 · 吃瓜 · 深扒
        </div>

        <h2 className="mt-6 max-w-3xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-[3.4rem] md:leading-[1.15]">
          一个页面看懂
          <br />
          黑料平台的全部玩法
        </h2>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200/85 md:text-base">
          从功能设置到内容板块，从服务方案到更新机制，这里把黑料平台的功能、内容、板块、服务与玩法讲清楚。想追热点、看爆料、吃瓜讨论，先花三分钟了解平台怎么运转。
        </p>

        <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href="#features"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            查看平台功能
            <i className="ri-arrow-right-line" />
          </a>
          <a
            href="#flash"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:border-background-50 hover:bg-background-50/10"
          >
            <span className="flex h-2 w-2 items-center justify-center">
              <span className="h-2 w-2 animate-soft-pulse rounded-full bg-accent-400" />
            </span>
            实时快讯流
          </a>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-100/15 bg-background-100/10 lg:grid-cols-4">
          {heroStats.map((stat) => (
            <div key={stat.label} className="bg-foreground-950/40 px-5 py-6">
              <div className="flex items-baseline gap-1">
                <span className="font-heading text-3xl font-bold text-background-50 md:text-4xl">
                  {stat.value}
                </span>
                <span className="text-sm font-medium text-accent-400">{stat.suffix}</span>
              </div>
              <p className="mt-2 text-xs text-background-200/70 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="relative z-10 border-t border-background-100/15 bg-foreground-950/60">
        <div className="flex overflow-hidden py-3">
          <div className="flex animate-marquee whitespace-nowrap">
            {[...heroTicker, ...heroTicker].map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="mx-6 inline-flex items-center gap-2 text-xs text-background-200/75"
              >
                <i className="ri-checkbox-blank-circle-fill text-[6px] text-primary-400" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}